import React, { useContext } from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { IBodyProps } from '../../Body/body';
import { LocalContext } from '../../../../../utils/providers/locale';
import { options } from '../Blog/blogBody';

export const LegalBody = ({ richBody }: IBodyProps) => {
  const locale = useContext(LocalContext)[0];
  const contentfulLocal = () => {
    const arr = locale.toLowerCase().split('-');
    return `${arr[0]}${arr[1] && `-${arr[1].toUpperCase()}`}`;
  };

  const key = contentfulLocal().includes('en') ? 'en' : contentfulLocal();
  return richBody ? (
    <>{renderRichText(richBody, options(locale, key))}</>
  ) : (
    <></>
  );
};

export const ContentfulLegalBody = ({ body }) => (
  <div className='py-20 max-w-3xl'>
    <LegalBody {...body} />
  </div>
);
